<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import HelperUtils from '@/helpers/helper';

// Services
import AIGeneratorService from "@/services/AIGeneratorService";


// Lib
import isEmpty from "is-empty";

export default {
  name: "ai_generator",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "AI Generator Controller",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...DateUtils,
    ...HelperUtils,

    loadAssistants() {
      this.isLoading = false;
      AIGeneratorService.getAssistantsTEST()
          .then(response => {
            const { items } = response.data;
            this.assistants = items;
            if (items.length > 0) {
              this.assistant = items[0];
              this.assistantInstructions = items[0].instructions;
              this.loadThreads();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadAssistants"));
            this.isLoading = false;
          });
    },

    updateInstructions() {
      this.isUpdating = true;
      const params = {
        assistantId: this.assistant.assistantId,
        instructions: this.assistantInstructions
      };
      AIGeneratorService.updateAssistantTEST(params)
          .then((response) => {
            this.isUpdating = false;
            this.assistant.instructionsId = response.data.instructionsId;
            this.assistant.instructions = this.assistantInstructions;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.updateInstructions"));
            this.isUpdating = false;
          });
    },

    loadThreads() {
      const params = {
        assistantId: this.assistant.assistantId
      };

      AIGeneratorService.getThreads(params)
          .then(response => {
            const { items } = response.data;
            this.threads = items;
            if (items.length > 0) {
              this.thread = items[0];
              this.loadMessages();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadThreads"));
            this.isLoading = false;
          });
    },

    loadMessages() {
      const params = {
        threadId: this.thread.threadId
      };

      AIGeneratorService.getMessages(params)
          .then(response => {
            const { items } = response.data;
            this.messages = items.reverse();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.loadMessages"));
            this.isLoading = false;
          });
    },

    newThread() {
      this.messages = [];
      this.thread = null;
      this.user = {
        name: '',
        age: '',
        locality: '',
        country: 'FR',
        language: 'fr'
      };
      this.sender = {
        name: '',
        age: '',
        locality: '',
        country: 'FR',
      };
    },

    selectThread(thread) {
      if (!isEmpty(this.thread) && thread.threadId === this.thread.threadId) {
        return;
      }
      this.thread = thread;
      this.messages = [];
      this.loadMessages()
    },

    deleteThread(threadId) {
      const params = {
        threadId: threadId
      };

      AIGeneratorService.deleteThread(params)
          .then(() => {
            if (this.thread !== null && this.thread.threadId === threadId) {
              this.thread = null;
              this.messages = [];
              this.message.content = "";
              this.message.instructions = "";
              this.message.imageUrl = "";
            }

            let threadIndex = this.threads.findIndex(elt => elt.threadId === threadId);
            this.threads.splice(threadIndex, 1);
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("aigenerator.deleteThread"));
          });
    },

    sendMessageAndGenerateAnswer() {
      if ((isEmpty(this.message.content) && isEmpty(this.message.imageUrl)) || this.isSending) {
        window.console.log("bye bye");
        return;
      }

      if (isEmpty(this.sender.name) || isEmpty(this.sender.age) || isEmpty(this.sender.locality)
        || isEmpty(this.user.name) || isEmpty(this.user.age) || isEmpty(this.user.locality)) {
        this.$toast.error("Fill User & Sender data");
        return;
      }

      this.isSending = true;

      const params = {
        assistantId: this.assistant.assistantId,
        message: this.message.content,
        imageUrl: this.message.imageUrl,
        messageRole: "U",
        instructions: this.message.instructions,
        instructionsId: this.assistant.instructionsId,
        threadId: !isEmpty(this.thread) ? this.thread.threadId : null,
        thread: !isEmpty(this.thread) ? JSON.stringify(this.thread) : null,
        user: JSON.stringify(this.user),
        sender: JSON.stringify(this.sender),
      };

      AIGeneratorService.sendMessageTestAndGenerate(params)
          .then(response => {
            const { thread, data } = response.data;
            this.messages.push({
              content: params.message,
              messageRole: 'U',
              imageUrl: params.imageUrl,
              tokenInput: 0,
              tokenOutput: 0,
              instructions: ''
            });

            this.messages.push({
              content: data.message,
              messageRole: 'A',
              imageUrl: '',
              tokenInput: data.tokenInput,
              tokenOutput: data.tokenOutput,
              instructions: params.instructions,
            });
            this.message.content = "";
            this.message.instructions = "";
            this.message.imageUrl = "";

            this.isSending = false;

            let _thread = this.threads.find(elt => elt.threadId === thread.threadId);
            if (isEmpty(_thread)) {
              this.thread = thread;
              this.threads.push(thread);
            }
            else {
              _thread.tokenInput = thread.tokenInput;
              _thread.tokenOutput = thread.tokenOutput;
              _thread.lastMessage = data.message;
            }
          })
          .catch(error => {
            window.console.error(error);
            this.isSending = false;
            this.$toast.error(this.$t("aigenerator.createMessage"));
          });
    },

    sendMessage(type) {
      if (isEmpty(this.message.content) || this.isSending) {
        return;
      }

      this.isSending = true;

      const params = {
        assistantId: this.assistant.assistantId,
        message: this.message.content,
        messageRole: type === 'user' ? 'U' : 'A',
        instructions: this.message.instructions,
        instructionsId: this.assistant.instructionsId,
        threadId: !isEmpty(this.thread) ? this.thread.threadId : null,
        thread: !isEmpty(this.thread) ? JSON.stringify(this.thread) : null,
      };

      AIGeneratorService.sendMessageTest(params)
            .then(response => {
              const { thread } = response.data;

              this.messages.push({
                content: this.message.content,
                messageRole: type === 'user' ? 'U' : 'A',
                instructions: '',
                tokenOutput: 0,
                tokenInput: 0
              });

              this.message.content = "";
              this.message.instructions = "";
              this.isSending = false;

              let _thread = this.threads.find(elt => elt.threadId === thread.threadId);
              if (isEmpty(_thread)) {
                this.thread = thread;
                this.threads.push(thread);
              }
              else {
                _thread.tokenInput = thread.tokenInput;
                _thread.tokenOutput = thread.tokenOutput;
                _thread.lastMessage = params.content;
              }
            })
            .catch(error => {
              window.console.error(error);
              this.isSending = false;
              this.$toast.error(this.$t("aigenerator.createMessage"));
            });
    },

    isEmpty(value) {
      return isEmpty(value);
    }
  },

  mounted() {
    this.loadAssistants();
  },

  data() {
    return {
      isLoading: false,
      isSending: false,
      isUpdating: false,
      title: this.$t("menuitems.system.ai_generator"),
      assistants: [],
      assistant: null,
      thread: null,
      threads: [],
      messages: [],
      message: {
        content: "",
        instructions: "",
        imageUrl: ''
      },
      user: {
        age: '',
        name: '',
        locality: '',
        country: 'FR',
        language: 'fr'
      },
      sender: {
        age: '',
        name: '',
        locality: '',
        country: 'FR'
      },
      assistantInstructions: ""
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">

      <div class="col-12 col-md-6">
        <!-- Chat -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Play
              <b-button variant="primary" class="float-end w-md" @click="newThread()">New Chat</b-button>
            </h4>

            <div v-if="assistant != null" class="bg-light p-2 m-1" style="clear:both;">
              <h6><b>{{ assistant.assistantName }}</b>
                <br><small>{{ assistant.assistantId }}</small></h6>
              <p class="text-muted font-size-11">{{ assistant.model }}</p>
              <legend class="font-size-13 text-primary">Assistant Instructions {{ assistant.instructionsId }}</legend>
              <b-form-textarea
                  id="assistantInstructions"
                  v-model="assistantInstructions"
                  placeHolder="Assistant Instructions"
                  rows="6"
              >
              </b-form-textarea>
              <b-button v-show="!isUpdating" variant="primary" class="w-md mt-1" @click="updateInstructions()">Update Instructions</b-button>
              <vue-ellipse-progress
                  v-show="isUpdating"
                  :loading="isUpdating"
                  :angle="-90"
                  color="#50a5f1"
                  emptyColor="#999"
                  emptyColorFill="#f8f8fb"
                  :size="50"
                  :thickness="3"
                  :emptyThickness="2"
                  lineMode="out 2"
                  animation="bounce 700 400"
                  fontColor="#666"
                  :half="false"
                  class="mt-5 mb-5"
                  fontSize="1rem">
              </vue-ellipse-progress>
            </div>

            <div class="messagesContent mt-4">
              <h6>Discussion <span v-if="thread !== null" class="text-success">{{ thread.threadId }}</span></h6>
              <p v-if="thread !== null" class="bg-light font-size-11 p-2" >
                <span class="text-danger">Start Instructions</span><br>
                {{ thread.assistantInstructions }}
              </p>
              <div v-for="message in messages" :key="message.id">
                <p v-if="!isEmpty(message.instructions) " class="fst-italic text-primary text-center">
                  <small class="text-black"><b>New Instructions</b></small><br>
                  {{ message.instructions }}
                </p>
                <p>
                  <span
                      class="badge"
                      :class="{
                        'bg-success text-light': `${message.messageRole}` === 'A',
                        'bg-info text-light': `${message.messageRole}` === 'S',
                        'bg-light text-dark': `${message.messageRole}` === 'U',
                      }"
                  >{{ $t(`aigenerator.role_${message.messageRole}`) }}</span>

                  <span v-show="message.messageRole === 'A'" class="badge bg-dark text-white ms-2 me-2">tokens {{ message.tokenInput }} IN / {{ message.tokenOutput }} OUT</span>

                  <img v-if="!isEmpty(message.imageUrl)" :src="message.imageUrl" width="200" style="display:block;" class="mb-1" alt="" />
                  {{ message.content }}
                </p>
              </div>
            </div>
            <hr/>

            <div class="row">
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Woman Name" v-model="sender.name" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Woman Age" v-model="sender.age" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Woman City" v-model="sender.locality" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Woman Country" v-model="sender.country" />
              </div>
            </div>
            <div class="row mt-2 mb-2">
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Man Name" v-model="user.name" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Man Age" v-model="user.age" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Man City" v-model="user.locality" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Man Country" v-model="user.country" />
              </div>
              <div class="col-sm-auto">
                <b-input type="text" placeholder="Man Language" v-model="user.language" />
              </div>
            </div>

            <legend class="font-size-13 mt-2 text-primary">Url of image attached</legend>
            <b-input type="text" placeholder="type url" v-model="message.imageUrl" />

            <legend class="font-size-13 mt-2 text-primary">Prompt</legend>
            <b-textarea
                id="messageContent"
                v-model="message.content"
                placeHolder="Ton message"
                rows="3"
            >
            </b-textarea>

            <legend class="font-size-13 mt-2 text-primary">Message Instructions</legend>
            <b-form-textarea
                id="messageInstructions"
                v-model="message.instructions"
                placeHolder="Message Instructions"
                rows="3"
            >
            </b-form-textarea>
            <br>
            <b-button v-show="!isSending" variant="secondary" class="w-md me-2" @click="sendMessage('ia')">Add IA message</b-button>
            <b-button v-show="!isSending" variant="primary" class="w-md me-2" @click="sendMessage('user')">Add User message</b-button>
            <b-button v-show="!isSending" variant="success" class="w-md" @click="sendMessageAndGenerateAnswer()">Add & Generate answer</b-button>
            <vue-ellipse-progress
                v-show="isSending"
                :loading="isSending"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="50"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
        </div>

      </div>

      <div class="col-12 col-md-6">
        <!-- threads -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Chats</h4>

            <!-- Loader -->
            <div class="d-flex justify-content-center">
              <vue-ellipse-progress
                  v-show="isLoading"
                  :loading="isLoading"
                  :angle="-90"
                  color="#50a5f1"
                  emptyColor="#999"
                  emptyColorFill="#f8f8fb"
                  :size="100"
                  :thickness="3"
                  :emptyThickness="2"
                  lineMode="out 2"
                  animation="bounce 700 400"
                  fontColor="#666"
                  :half="false"
                  class="mt-5 mb-5"
                  fontSize="1rem">
              </vue-ellipse-progress>
            </div>

            <!-- Result list -->
            <div class="row bg-white" v-if="!isLoading && threads.length > 0">
              <div class="table-responsive card-body">
                <table
                    id="generator-list"
                    class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                >
                  <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">CreatedAt</th>
                    <th scope="col">Assistant</th>
                    <th scope="col">Token In/Out</th>
                    <th scope="col">Last Message</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in threads" :key="row.threadId">
                    <td>
                      <b-button @click="deleteThread(row.threadId)">
                        DELETE
                      </b-button>
                    </td>
                    <td @click="selectThread(row)">
                      <p class="text-muted font-size-12">
                        {{ formatDateString(row.createdAt, 'DD MMM YYYY HH:mm') }}
                        <br><small>{{ row.threadId }}</small>
                      </p>

                    </td>
                    <td @click="selectThread(row)">
                      <p class="text-muted font-size-12">
                        <b> {{ row.assistantName }}</b>
                        <br><small>{{ row.assistantId}}</small>
                      </p>
                    </td>
                    <td @click="selectThread(row)">
                      <p class="text-muted font-size-14">
                        {{ row.tokenInput }}/{{ row.tokenOutput }}
                      </p>
                    </td>
                    <td>
                      <p class="text-muted font-size-11">
                        {{ row.lastMessage}}
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Result Empty -->
            <div class="m-3" v-if="!isLoading && threads.length === 0">
              <h4 class="card-title">Empty Result</h4>
              <p>No Contents were found for these filters or search. Try again.</p>
            </div>

          </div>
        </div>

      </div>


    </div>

  </Layout>
</template>

<style>
.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}
</style>
